export enum MainRoutingPathsEnum {
  HomeContractor = 'home-contractor',
  DocumentParse = 'document-parse',
  Dictionary = 'dictionary',
  DictionaryDetails = 'dictionary/:groupId',
  LegalHelper = 'legal-helper',
  CorporateProposal = 'corporate-proposal',
  EstimateGenerator = 'estimate-generator',
  Purchases = 'purchases',
  PriceRequests = 'price-requests',
  SupplierRequests = 'supplier-requests',
  SupplierCabinet = 'supplier-cabinet',
  AboutUs = 'about-us',
  Forbidden = 'forbidden',
  SubscriptionExpired = 'subscription-expired',
  NotFound = 'not-found',
}
